import React from "react";

import { FlexContainer } from "@/components/Atoms";
import { Typography } from "@/foundation/Typography/V1";
import theme from "@/foundation/Theme";

import { BrandImage, StyledButton, Wrapper, WrapperDiv } from "./style";

const HeroSection = ({
  banner,
  partnerLogo,
  partnerLogoWidth,
  subtitle,
  title,
  ctaTitle,
  heroPadding,
  contentWidth,
  ogMeta,
}) => {
  const h1 = ogMeta?.h1_title;

  return (
    <Wrapper banner={banner} heroPadding={heroPadding}>
      {partnerLogo && (
        <BrandImage
          src={partnerLogo}
          width={partnerLogoWidth || "120px"}
          bottom="20px"
        />
      )}
      <FlexContainer flexDirection={"column"} position="relative" zIndex={"1"}>
        <WrapperDiv contentWidth={contentWidth}>
          {subtitle && (
            <Typography
              fontFamily={"var(--font-600)"}
              variant={"paragraph1"}
              color={theme.colors.white}
            >
              {subtitle}
            </Typography>
          )}
          {h1 && <h1 className="seo-heading-1">{h1}</h1>}
          <Typography
            variant={h1 ? "heading2" : "heading1"}
            fontSize={["24px", "34px", "34px"]}
            color={theme.colors.white}
            lineHeight={"normal"}
          >
            {title}
          </Typography>
          {ctaTitle && (
            <StyledButton
              mt={"25px"}
              variant={"primary1"}
              bgColor={theme.colors.yellow}
              hoverColor={`${theme.colors.yellow}eb`}
              fontFamily={"var(--font-700)"}
              fontSize={"18px"}
              onClick={() => {}}
            >
              {ctaTitle}
            </StyledButton>
          )}
        </WrapperDiv>
      </FlexContainer>
    </Wrapper>
  );
};

export default HeroSection;
